import React from 'react';
import {AuthedLayout} from 'components/Layout';

const PipelinesDashboardLazy = React.lazy(() => import(/* webpackChunkName: "PipelinesDashboard" */ './PipelineDashboard'));

export const PipelinesDashboard = props => <AuthedLayout component={PipelinesDashboardLazy} {...props} />;
